import { render } from "./BoardNoticeManageListForm.vue?vue&type=template&id=3df06128&lang=true"
import script from "./BoardNoticeManageListForm.vue?vue&type=script&lang=js"
export * from "./BoardNoticeManageListForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__